import request from '@/plugins/request';
import { IBoolResult } from '@/types/dto';
import { ITheme } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/admin/themes';
const $urlSetTags = '/admin/themes/actions/setTags';

interface IGetRequest {
  state: string;
}

interface IGetResult {
  themes: ITheme[];
  allTagNames: string[];
  allCount: number;
  pendingCount: number;
  publishedCount: number;
  rejectedCount: number;
}

interface IDeleteRequest {
  userName: string;
  name: string;
}

interface ISubmitRequest {
  userName: string;
  name: string;
  state: string;
  message: string;
  isFeatured: boolean;
}

interface ISetTagsRequest {
  userName: string;
  name: string;
  tags: string[];
}

export default {
  get(req: IGetRequest, success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url, {
        params: req,
      })
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  delete(req: IDeleteRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .delete($url, {
        data: req,
      })
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  submit(req: ISubmitRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .put($url, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  setTags(req: ISetTagsRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .put($urlSetTags, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
